export enum HolidayState {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
    REQUESTED_DELETE = 'REQUESTED_DELETE',
    DELETION_REQUEST_DENIED = 'DELETION_REQUEST_DENIED',
    DELETION_APPROVED = 'DELETION_APPROVED',
    REQUESTED_DELETE_FROM_APPROVED = 'REQUESTED_DELETE_FROM_APPROVED',
}
